// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"780":"18299796","964":"3b1a84cd"}[chunkId] + ".chunk.css";
};